import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "button"]

  connect() {
    console.log("Payment status controller connected")
  }

  // Handle successful payment status update
  paymentSuccess(event) {
    if (!confirm("Are you sure you want to mark this reservation as paid with cash?")) {
      event.preventDefault()
      return
    }
    
    console.log("Payment success action triggered")
  }
}
